<script setup lang="ts">
const { slice } = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

const bannerStyles = computed(() => {
  let style = 'mixed'

  style = slice.Banners.every((banner) => {
    return ['topleft', 'top', 'topright', 'left', 'center', 'right', 'bottomleft', 'bottom', 'bottomright'].includes(banner.ContentPosition)
  })
    ? 'overlay'
    : style

  style = slice.Banners.every((banner) => {
    return ['asideleft', 'asideright'].includes(banner.ContentPosition)
  })
    ? 'wide'
    : style

  style = slice.Banners.every((banner) => {
    return ['above', 'below'].includes(banner.ContentPosition)
  })
    ? 'high'
    : style

  return style
})
</script>

<template>
  <StrapiSlice
    class="ct-banner-feed"
    :class="`ct-banner-feed--${bannerStyles}`"
    :slice="slice"
    :index="index"
  >
    <UiCarousel
      v-if="slice?.FeedDisplay?.Display === 'Slider'"
      class="ct-banner-feed__carousel"
      :style="`--items: ${slice?.Banners?.length}`"
      :class="{
        /* Non responsive & non modern settings */
        'ui-carousel--center': false,
        'ui-carousel--free-scroll': true,
        'ui-carousel--navigation': true,
        'ui-carousel--pagination': false,
        'ui-carousel--progress': false,
      }"
    >
      <template
        v-for="(banner, i) in slice?.Banners"
        #[`slide-${i}`]
        :key="banner"
      >
        <StrapiBanner
          :banner="banner"
          :lazy="index > 0"
          :banner-count="slice?.Banners?.length"
          :full-width="slice?.Settings?.SliceWidth?.toLowerCase() === 'full_width'"
          class="ct-banner-feed__banner"
        />
      </template>
    </UiCarousel>

    <div
      v-else-if="['Grid', 'Masonry'].includes(slice?.FeedDisplay?.Display)"
      :class="{
        'ct-banner-feed__grid': slice?.FeedDisplay?.Display !== 'Masonry',
        'ct-banner-feed__masonry': slice?.FeedDisplay?.Display === 'Masonry',
      }"
      :style="`--columns: ${slice?.Banners?.length};`"
    >
      <StrapiBanner
        v-for="banner in slice?.Banners"
        :key="banner"
        :banner="banner"
        :lazy="index > 0"
        :banner-count="slice?.Banners?.length"
        :full-width="slice?.Settings?.SliceWidth?.toLowerCase() === 'full_width'"
        :class="['ct-banner-feed__banner', { 'banner--hero': slice?.Banners?.length === 1 && slice?.Settings?.SliceWidth?.toLowerCase() === 'full_width' }]"
      />
    </div>
  </StrapiSlice>
</template>

<style>
@import url("~layers/app/components/Slices/BannerFeed.css");
</style>
